import PropTypes from "prop-types"
import React from "react"
import { twMerge } from "tailwind-merge"

const tags = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  hxl: "h1",
  body: "div",
  small: "span",
  micro: "span",
  subtitle: "div",
  smSubtitle: "div",
  title: "div",
  capitalHeading: "h2"
}

const classNames = {
  h1: "font-bold text-[36px] leading-[44px] md:text-[56px] md:leading-[64px]",
  h2: "font-bold text-[32px] leading-[40px] md:text-[40px] md:leading-[48px]",
  // h3: "font-bold text-[24px] leading-[32px] md:text-[32px] md:leading-[40px]",
  h3: "font-bold text-[24px] leading-normal md:text-[28px] md:leading-[32px]",
  h4: "font-bold text-[20px] leading-[28px] md:text-[24px] md:leading-[32px]",
  h5: "font-bold text-[16px] leading-[24px] md:text-[18px] md:leading-[24px]",
  hxl: "font-bold sm:text-[40px] sm:leading-[48px] text-[56px] leading-[64px]",
  body: "text-[16px] leading-[24px]",
  small: "text-[14px] leading-[20px]",
  micro: "text-[12px] leading-[16px] text-gray-dark",
  subtitle: "text-gray-dark",
  smSubtitle: "text-gray-dark text-sm",
  title: "font-bold mb-1",
  capitalHeading: "font-bold text-gray-dark text-sm uppercase tracking-wider"
}

const Typography = ({ variant = "body", children, className, as }) => {
  const sizeClassNames = classNames[variant]
  const Tag = as || tags[variant]

  return <Tag className={twMerge(sizeClassNames, className)}>{children}</Tag>
}

Typography.propTypes = {
  variant: PropTypes.oneOf(Object.keys(classNames)).isRequired
}

export default Typography
